import {
  CDRDefinition,
  CDRResponse,
  NumberingResponse,
  NumberingScheme,
  PTMSite,
} from 'molbio/antibody-engineering/AntibodyEngineeringConstants';
import {postJSONPromise} from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

export type BulkNumberingResponse = Array<NumberingResponse>;

export async function getNumbering(
  aminoAcids: Array<string>,
  scheme: NumberingScheme
): Promise<BulkNumberingResponse> {
  return await TaskRunner.postJSONPromise({
    url: `/1/api/proteins:number-as-antibody`,
    data: {aaSequences: aminoAcids, scheme},
  });
}

export type BulkCDRAnnotationResponse = Array<CDRResponse>;

export async function getCDRAnnotations(
  aminoAcids: Array<string>,
  definition: CDRDefinition
): Promise<BulkCDRAnnotationResponse> {
  return await TaskRunner.postJSONPromise({
    url: `/1/api/proteins:identify-antibody-cdrs`,
    data: {aaSequences: aminoAcids, definition},
  });
}

type PTMResponse = Array<Array<PTMSite>>;

export async function getPostTranslationalModifications(aaSequences: Array<string>): Promise<PTMResponse> {
  return await postJSONPromise({url: '/1/api/proteins:identify-ptms', data: {aaSequences}});
}
